import { render, staticRenderFns } from "./TeacherProfileSetting.vue?vue&type=template&id=f1dfa9a6&scoped=true&"
import script from "./TeacherProfileSetting.vue?vue&type=script&lang=js&"
export * from "./TeacherProfileSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1dfa9a6",
  null
  
)

export default component.exports